module.exports = __webpack_public_path__ + "img/title_gdhsdt.7639dcbc.png";